import { createPortal } from 'react-dom';

const Portal = ({ target, children }) => {
  if (!target) return null;
  return createPortal(children, target);
};

export default Portal;